<template>
  <div>
    <div>
      <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" length="1000"></ckeditor>
      <button class="btn btn-outline-behance btn-block mt-2" @click="submit">ذخیره</button>
    </div>
    <hr>
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>ردیف</th>
            <th>نویسنده</th>
            <th>متن</th>
            <th>تاریخ ارسال</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr" v-for="(message, index) in data" :key="index">
            <td>{{index+1}}</td>
            <td>{{message.user.name}}</td>
            <td v-html='message.body'></td>
            <td>{{message.time}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
  name: 'dailyReport',
  props: ['data'],
  data () {
    return {
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
        contentsLangDirection: 'rtl',
        language: 'fa',
        toolbar: {
          items: ['bold', 'italic', 'link', 'undo', 'redo', 'NumberedList', 'BulletedList']
        }
      }
    }
  },
  methods: {
    submit () {
      this.$send.submit('post', '/api/project/daily-report/' + this.$route.params.id, { body: this.editorData })
        .then(response => {
          this.editorData = ''
          this.$parent.startDailyReport()
        })
    }
  }
}
</script>

<style>

</style>
